import { render } from "./AdminSettingsView.vue?vue&type=template&id=b85db3fe"
import script from "./AdminSettingsView.vue?vue&type=script&lang=js"
export * from "./AdminSettingsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__